import React from 'react';
import EvolutionChart from './EvolutionChart';
import AccumulatedPpaChart from './AccumulatedPpaChart';

/**
 * Renderiza el bloque EvolutionSection de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function EvolutionSection({
  v
}) {
  return React.createElement("section", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "backdropFilter": "blur(0.555556vh)",
      "padding": "1.111111vh 1.481481vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh",
      "flex": "1",
      "minWidth": "0",
      "height": "auto",
      "minHeight": "0"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexWrap": "wrap",
      "justifyContent": "space-between",
      "alignItems": "center",
      "gap": "0.740741vh 1.111111vh"
    }
  }, v.text("\n          "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "baseline",
      "gap": "1.111111vh",
      "minWidth": "0",
      "flex": "1 1 15.625vw",
      "order": "0"
    }
  }, v.text("\n            "), React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.481481vh",
      "fontWeight": "600",
      "whiteSpace": "nowrap"
    }
  }, v.text("Evolución")), v.text("\n            "), React.createElement("span", {
    style: {
      "fontSize": "1.203704vh",
      "color": "#b8c1ce",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text(v.tabInsight)), v.text("\n          ")), v.text("\n          "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh",
      "flex": "1 1 100%",
      "minWidth": "0",
      "alignItems": "flex-start",
      "order": "2"
    }
  }, v.text("\n            "), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.740741vh",
      "alignItems": "center",
      "flexWrap": "wrap"
    }
  }, v.text("\n            "), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, (v.sMainM || []).map((m, index53) => React.createElement(React.Fragment, {
    key: index53
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "whiteSpace": "nowrap",
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.277778vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color,
      "fontWeight": m.fw
    }
  }, v.text(m.label), React.createElement("span", {
    style: {
      "marginLeft": "0.260417vw",
      "fontSize": "0.833333vh",
      "opacity": "0.6"
    }
  }, v.text(m.caret)))))), v.text("\n            "), React.createElement("button", {
    "onClick": v.mixBtn.onClick,
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "borderRadius": "0.555556vh",
      "padding": "0.37037vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "border": "0.092593vh solid " + v.mixBtn.bd,
      "background": v.mixBtn.bg,
      "color": v.mixBtn.color
    }
  }, React.createElement("span", {
    style: {
      "width": "1.354167vw",
      "height": "1.296296vh",
      "borderRadius": "0.648148vh",
      "background": v.mixBtn.track,
      "position": "relative"
    }
  }, React.createElement("span", {
    style: {
      "whiteSpace": "nowrap",
      "flex": "none",
      "position": "absolute",
      "top": "0.185185vh",
      "left": v.mixBtn.knob,
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "50%",
      "background": "#e4e9f0"
    }
  }, null)), v.text("Combinar métricas")), v.text("\n            \n            "), v.tabEvo ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.740741vh"
    }
  }, v.text("\n            "), React.createElement("div", {
    style: {
      "display": (v.sGroups || []).length ? "flex" : "none",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, (v.sGroups || []).map((m, index54) => React.createElement(React.Fragment, {
    key: index54
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.277778vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color
    }
  }, v.text(m.label))))), v.text("\n            \n            "), v.showAxes ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh",
      "alignItems": "center"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#5a667a",
      "padding": "0 0.555556vh"
    }
  }, v.text("Eje X")), (v.sAxes || []).map((m, index55) => React.createElement(React.Fragment, {
    key: index55
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.277778vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color
    }
  }, v.text(m.label)))))) : null, v.text("\n          "))) : null), v.text("\n            "), v.sHasSub ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.185185vh",
      "padding": "0.185185vh",
      "borderRadius": "0.555556vh",
      "background": "#121b2b",
      "border": "0.092593vh solid #243149"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#5a667a",
      "padding": "0 0.555556vh 0 0.555556vh"
    }
  }, v.text(v.sSubTitle)), (v.sSubM || []).map((m, index56) => React.createElement(React.Fragment, {
    key: index56
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "whiteSpace": "nowrap",
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.277778vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color,
      "fontWeight": m.fw
    }
  }, v.text(m.label)))))) : null, v.text("\n          ")), v.text("\n          "), v.tabPpa ? React.createElement(React.Fragment, null, React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#8793a6",
      "flex": "none"
    }
  }, v.text("Pendiente = pérdida diaria"))) : null, v.text("\n          "), React.createElement("button", {
    "onClick": v.expEvo.onClick,
    "title": v.expEvo.title,
    style: {
      "order": "1",
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "background": "rgba(20,38,62,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.18)",
      "color": "#e4e9f0",
      "borderRadius": "0.555556vh",
      "padding": "0.37037vh 0.925926vh",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "whiteSpace": "nowrap",
      "flex": "none"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.203704vh",
      "lineHeight": "1"
    }
  }, v.text(v.expEvo.icon)), v.text(v.expEvo.label)), v.text("\n        ")), v.text("\n        "), v.expCagesOn ? React.createElement(React.Fragment, null, v.text("\n          "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexWrap": "wrap",
      "alignItems": "center",
      "gap": "0.555556vh",
      "padding": "0.740741vh 0.925926vh",
      "borderRadius": "0.740741vh",
      "background": "rgba(3,10,22,0.5)",
      "border": "0.092593vh solid rgba(46,179,238,0.12)"
    }
  }, v.text("\n            "), React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#8793a6",
      "marginRight": "0.208333vw"
    }
  }, v.text("Jaulas")), v.text("\n            "), (v.expCages || []).map((g, index57) => React.createElement(React.Fragment, {
    key: index57
  }, v.text("\n              "), React.createElement("button", {
    "onClick": g.onClick,
    "title": g.title,
    style: {
      "whiteSpace": "nowrap",
      "flex": "none",
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "padding": "0.37037vh 0.925926vh",
      "borderRadius": "1.296296vh",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Mono',monospace",
      "border": "0.092593vh solid " + g.bd,
      "background": g.bg,
      "color": g.txt,
      "fontWeight": g.fw
    }
  }, React.createElement("span", {
    style: {
      "width": "0.416667vw",
      "height": "0.740741vh",
      "borderRadius": "50%",
      "background": g.dot
    }
  }, null), v.text(g.name)), v.text("\n            "))), v.text("\n            "), React.createElement("span", {
    style: {
      "marginLeft": "auto",
      "display": "flex",
      "gap": "0.925926vh",
      "fontSize": "1.111111vh",
      "flex": "none",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("a", {
    "onClick": v.expTop3,
    style: {
      "cursor": "pointer"
    }
  }, v.text("Top 3 alarmas")), React.createElement("a", {
    "onClick": v.expAll,
    style: {
      "cursor": "pointer"
    }
  }, v.text("Todas")), React.createElement("a", {
    "onClick": v.expNone,
    style: {
      "cursor": "pointer"
    }
  }, v.text("Solo " + v.selName))), v.text("\n          ")), v.text("\n        ")) : null, v.text("\n        "), React.createElement(EvolutionChart, {
    v
  }), v.text("\n        "), React.createElement(AccumulatedPpaChart, {
    v
  }), v.text("\n      "));
}
